import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import { DeleteDialogProps } from "../../../interface/dialog/DeleteDialogProps";
import Button from "../Button";
import { useDialogStyles } from "./styles";

const DeleteDialog = ({
  open,
  onClose,
  onConfirmDelete,
}: DeleteDialogProps) => {
  const classes = useDialogStyles();
  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="xs">
      <DialogTitle className={classes.dialogTitle}>
        {"Confirm Deletion?"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>
          Are you sure you want to permanently remove this item?
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            type="button"
            onClick={() => onClose()}
            color="default"
            variant="contained"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Delete"
            type="button"
            onClick={() => onConfirmDelete()}
            autoFocus
            color="primary"
            variant="contained"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
